import { render, staticRenderFns } from "./NflNewsComponent.vue?vue&type=template&id=27da16e0"
import script from "./NflNewsComponent.vue?vue&type=script&lang=js"
export * from "./NflNewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports